import { useEffect, useState } from 'react';
export default function useFilterFixed({
  scrollBody,
  hideTop = 200,
  minHeight,
}: {
  scrollBody?: React.MutableRefObject<any>;
  hideTop?: number;
  minHeight: number;
}) {
  const [filterFixed, setFilterFixed] = useState(false);

  useEffect(() => {
    const handleScroll = (event: any) => {
      if (event.target === scrollBody?.current) {
        let scrollTop = event.srcElement.scrollTop;
        // 滚动判断 200 和筛选器位置相关，开发调整
        if (scrollTop > minHeight) {
          setFilterFixed(true);
        } else {
          setFilterFixed(false);
        }
      }
    };
    if (scrollBody?.current) {
      scrollBody.current?.addEventListener('scroll', handleScroll, true);
      return () =>
        scrollBody.current?.removeEventListener('scroll', handleScroll, true);
    }
  }, [hideTop, minHeight, scrollBody]);

  return { filterFixed };
}
